/* eslint-disable padding-line-between-statements */
import React, { useCallback, useState, useContext, useMemo } from 'react';
import _ from 'lodash';
import { useModal, InlineNotification } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { CpCoverablesService } from "twia-capability-quoteandbind-cp";
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil.js';
import TWIABuildingStepper from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingStepper/TWIABuildingStepper.jsx';
import BuildingLocationContext from 'twia-capability-quoteandbind-cp-react/context/BuildingsAndLocationContext.jsx';
import TWIABuildingList from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingList/TWIABuildingList.jsx';
import LocationStep from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingWizardSteps/LocationStep/LocationStep.jsx';
import BuildingStep from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingWizardSteps/BuildingStep/BuildingStep.jsx';
import CoveragesStep from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingWizardSteps/CoveragesStep/CoveragesStep.jsx';
import ConstructionStep from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingWizardSteps/ConstructionStep/ConstructionStep.jsx';
import AdditionalInterestsStep from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingWizardSteps/AdditionalInterestsStep/AdditionalInterestsStep.jsx';
import ConfirmationStep from 'twia-capability-quoteandbind-cp-react/components/TWIABuildingWizardSteps/ConfirmationStep/ConfirmationStep.jsx';
import BuildingLocationUtil from 'twia-capability-quoteandbind-cp-react/util/BuildingLocationUtil.js';
import { GatewayEndorsementService as LoadSaveService} from 'twia-capability-gateway-policychange';
import TWIACPCoveragesUtil from "twia-capability-renewal-cp-react/util/TWIACPCoveragesUtil.js";
import styles from './BuildingsAndLocationsPage.module.scss';
import messages from './BuildingsAndLocationsPage.messages.js'
import metadata from './BuildingsAndLocationsPage.metadata.json5';


function BuildingsAndLocationsPage(props) {
    const { id, wizardData: submissionVM, updateWizardData } = props;
    const translator = useContext(TranslatorContext);
    const { showConfirm, showAlert } = useModal();
    const { authHeader } = useAuthentication();

    const { isComponentValid,initialValidation, onValidate } = useValidation(id);
    const [showErrors, setShowErrors] = useState(false);
    const [wizardStep, setWizardStep] = useState(-1);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [newlyAddedBuildingList, setNewlyAddedBuildingList] = useState([])
    const [viewingLocationOrBuilding, setViewingLocationOrBuilding] = useState(false)
    const [hasBuildingList, setHasBuildingList] = useState(true);
    const [showStepper, setShowStepper] = useState(true);
    const [showViewLocation, setShowViewLocation] = useState(false);
    const [showViewCoverages, setshowViewCoverages] = useState(false);
    const [editLocationBuilding, setEditLocationBuilding] = useState(false);
    const [errorSets, setErrorSets] = useState([]);
    const { refreshData } = useDataRefresh();
    const viewModelService = useContext(ViewModelServiceContext);
    const [showCoverageError, setShowCoverageError] = useState(false);
    const [showLocationAccordion,setShowLocationAccordion] = useState(true);
    const [showBuildingAccordion,setShowBuildingAccordion] = useState(true);
    const [showCoverageAccordion,setShowCoverageAccordion] = useState(true);
    const [showConstructionAccordion,setShowConstructionAccordion] = useState(true);
    const [showAdditionalInterestAccordion,setShowAdditionalInterestAccordion] = useState(true);
    const [showBuildingList,setShowBuidlingList] = useState(false);
    const jobID = submissionVM.jobID.value;
    const sessionID = submissionVM.sessionUUID.value;
    const startWizard = () => {
        setWizardStep(0)
        setShowStepper(true)
        submissionVM.isAddBuilding = true   
    }

    const locations = _.get(submissionVM, 'lobData.commercialProperty.coverables.locations.value')
    const hasBuildings = locations.some(loc => loc.buildings && loc.buildings.length > 0);

    const steps = [
        {
            "title": translator(messages.locationStep)
        },
        {
            "title": translator(messages.buildingStep)
        },
        {
            "title": translator(messages.constructionStep)
        },
        {
            "title": translator(messages.coveragesStep)
        },
        {
            "title": translator(messages.additionalInterestsStep)
        }
    ]

    const handleNextClick = useCallback(() => {
        if (showStepper) {
            setWizardStep(wizardStep + 1)
            setShowViewLocation(false);
        } else if (wizardStep !== 0 || editLocationBuilding) {
                setshowViewCoverages(true);
                setShowViewLocation(false);
                setShowLocationAccordion(true)
                setShowBuildingAccordion(true)
                setShowConstructionAccordion(true)
                setShowCoverageAccordion(true)
                setShowAdditionalInterestAccordion(true)
                setShowBuidlingList(false)
                setShowStepper(true)
                setWizardStep(-1);
            } else {
                setShowStepper(true)
                setShowViewLocation(true);
                setshowViewCoverages(false);
                setWizardStep(-1);              
            }
    }, [editLocationBuilding, showStepper, wizardStep])

    const handleCancelClick = useCallback(async (selectedLocation, setSelectedLocation) => {
        if (showStepper) {
            showConfirm({
                title: messages.cancelModalTitle,
                message: messages.cancelModalDescription,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.yesModel,
                cancelButtonText: commonMessages.noModel,
            }).then(async (results) => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }

                if (selectedLocation) {
                    if (
                        ((selectedLocation.buildings.length > 0) && submissionVM.selectedBuilding)
                    ) {
                        await BuildingLocationUtil.removeCPBuilding(submissionVM, submissionVM.setSelectedBuildingIndex, authHeader)
                        submissionVM.selectedBuilding = null
                        setSelectedLocation(selectedLocation);
                    }
                }

                if (selectedLocation && !selectedLocation.isPrimary.value && 
                    (selectedLocation.buildings.length === 0 ||
                    (selectedLocation.buildings.length === 1 && submissionVM.selectedBuilding))) {
                    BuildingLocationUtil.removeLocation(selectedLocation, submissionVM,
                        authHeader, setSelectedLocation)
                }

                setWizardStep(-1);
                setShowViewLocation(false);

                return results
            })
        } else {
            if (setSelectedLocation && selectedLocation) {
                setSelectedLocation(selectedLocation);
            }

            if (wizardStep !== 0 || editLocationBuilding) {
                setshowViewCoverages(true);
                setShowViewLocation(false);
                setShowLocationAccordion(true)
                setShowBuildingAccordion(true)
                setShowConstructionAccordion(true)
                setShowCoverageAccordion(true)
                setShowAdditionalInterestAccordion(true)
                setShowBuidlingList(false)
                setShowStepper(true)
                setWizardStep(-1);
            } else {
                setShowStepper(true)
                setWizardStep(-1);
                setShowViewLocation(true)
                setshowViewCoverages(false);
            }
            submissionVM.isAddBuilding = false    
        }
    }, [authHeader, editLocationBuilding, showConfirm, showStepper, submissionVM, wizardStep])

    const handleDoneClick = useCallback((setSelectedLocation) => {
        submissionVM.selectedLocation = null
        setSelectedLocation(null)
        setWizardStep(-1);
        submissionVM.isAddBuilding = false
    }, [submissionVM])

    const handleAnotherClick = useCallback(() => {
        submissionVM.selectedBuilding = null;
        updateWizardData(submissionVM)
        setWizardStep(0)
        submissionVM.isAddBuilding = true

    }, [submissionVM, updateWizardData])

    const showHideBuildingList = useCallback(() => {
        setShowBuidlingList(false);
        setshowViewCoverages(true)
        setShowStepper(true)
        setShowLocationAccordion(true)
        setShowBuildingAccordion(true)
        setShowConstructionAccordion(true)
        setShowCoverageAccordion(true)
        setShowAdditionalInterestAccordion(true)
        setWizardStep(-1)
    },[])

    const showHideAccordion = useCallback((step,dontShowStepper,isEditViewLocation)=>{
        if(step === 0 && !dontShowStepper && !isEditViewLocation){
           setShowLocationAccordion(false)
        }
        if(step === 1 && !dontShowStepper){
            setShowBuildingAccordion(false)
            setShowConstructionAccordion(false)
        }
        if(step === 2 && !dontShowStepper){
            setShowConstructionAccordion(false)
            setShowCoverageAccordion(false)
            setShowAdditionalInterestAccordion(false)
        }
        if(step === 3 && !dontShowStepper){
            setShowCoverageAccordion(false)
            setShowAdditionalInterestAccordion(false)
        }
        if(step === 4 && !dontShowStepper){
            setShowAdditionalInterestAccordion(false)
        }
    },[])

    const handleEditLinkClick = useCallback((step, dontShowStepper, isEditLocationBuilding,isEditViewLocation) => {
        setWizardStep(step)
        submissionVM.isAddBuilding = false    // DE15783

        if (dontShowStepper === false) {
            setShowStepper(false);   
            setshowViewCoverages(true)       
            setShowBuidlingList(true); 
            showHideAccordion(step,dontShowStepper,isEditViewLocation);   
        } else {
            setShowStepper(true);
        }
        if (isEditLocationBuilding === true) {
            setEditLocationBuilding(true);
        } else {
            setEditLocationBuilding(false);
        }
        if(isEditViewLocation){
            setShowBuidlingList(false)
        }
    }, [showHideAccordion, submissionVM])

    // Temporary fix for a valid selectedLocation and selected Building.
    const selectedLocation = submissionVM.value.lobData.commercialProperty.coverables.locations[0];

    const selectedBuilding = submissionVM.value.lobData.commercialProperty.coverables.locations[0]?.buildings[0];

    const isCommercial = !_.isUndefined(_.get(submissionVM, 'value.lobData.commercialProperty'));

    const getErrorMessages = useCallback((validationIssues) => {

        let isValidationIssueAvailable = false;

        if (validationIssues && ((validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0)
            || (validationIssues.issues && validationIssues.issues.length > 0))) {

            let flowErrors = [];
            let validationFlowReasons = [];

            if (validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0) {
                flowErrors = validationIssues.fieldIssues.filter((item) =>
                    item.flowStepId === "CPBuildings")
                    .map((item) => {
                        if (
                            item.relatedEntity?.fieldName === 'EstimatedCompletionDate_TWIA'
                            && !item.reason.includes('Missing required field')
                        ) {
                            return `${item.relatedEntity.displayName} ${item.reason}`;
                        }
                        return item.reason;
                    });
            }

            if (validationIssues.issues && validationIssues.issues.length > 0) {
                validationFlowReasons = validationIssues.issues.filter((item) =>
                    item.flowStepId === "CPBuildings").map((item) => item.reason);
            }

            refreshData();

            const errorAndValidationMessages = [...flowErrors, ...validationFlowReasons];

            if (errorAndValidationMessages.length > 0) {
                setErrorSets(errorAndValidationMessages);
                isValidationIssueAvailable = true;
            } else {
                setErrorSets([]);
                isValidationIssueAvailable = false;
            }

        } else {
            setErrorSets([]);
            refreshData();
            isValidationIssueAvailable = false
        }

        return isValidationIssueAvailable;
    }, [setErrorSets, refreshData]);

    
    const validateCoverages = useCallback(() => {
        if (submissionVM.value.errorsAndWarnings) {
            const result = getErrorMessages(submissionVM.value.errorsAndWarnings
                .validationIssues);

            if (result) {
                setShowCoverageError(true);
                return true;
            }
            setShowCoverageError(false);
            return false;
        }
        return !!submissionVM.value
    }, [submissionVM, getErrorMessages])

    const errorContent = useCallback(
        item => (
            <InlineNotification id={item}
                message={item}
                type="error"
                className={wizardStyles.validationMargin}
                isDismissable={false}
            />
        ), []);

    const generateOverrides = useMemo(() => {

        const overrides = errorSets.map((item, index) => ({
            [`errorMsg${index}`]: {
                content: errorContent(item),
            },
        }));

        return Object.assign({}, ...overrides);
    }, [errorSets, errorContent]);

    // DE16206
    const updateAndRemoveUnwantedLoc = useCallback(async () => {
        const allLocations = submissionVM.lobData.commercialProperty.coverables.locations.children;
        const locWithoutBldg = allLocations.find((loc) => loc.buildings.value.length === 0);
        if (locWithoutBldg && locWithoutBldg.isPrimary.value) {
            const newPrimaryLocation = allLocations.find((loc) => loc.publicID.value !==
                locWithoutBldg.publicID.value);
            newPrimaryLocation.isPrimary.value = true;
            const updateLoc = await CpCoverablesService.updateCPLocation(
                jobID,
                newPrimaryLocation.value,
                sessionID,
                authHeader
            )
            _.remove(submissionVM.lobData.commercialProperty.coverables.locations.value,
                (currLocation) => currLocation.publicID === newPrimaryLocation.publicID.value);
            await BuildingLocationUtil.removeLocation(locWithoutBldg, submissionVM,
                authHeader);
            submissionVM.lobData.commercialProperty.coverables.locations
                .value.push(updateLoc);
            updateWizardData(submissionVM);
        }
    }, [authHeader, jobID, sessionID, submissionVM, updateWizardData]);

    const saveData = useCallback(async () => {
        try {
            await updateAndRemoveUnwantedLoc();
            _.unset(submissionVM.value, 'bindData');
            const newSubmissionVM = viewModelService.clone(submissionVM);

            submissionVM.value = await LoadSaveService.quoteEndorsement(
                [jobID],
                authHeader
            )
            
            updateWizardData(submissionVM);
            return submissionVM
        } catch {
            ErrorPopupUtil.showQuoteErrorPopup(showAlert, true);
            return false;
        }
    }, [updateAndRemoveUnwantedLoc, submissionVM, viewModelService, jobID, 
        authHeader, updateWizardData, showAlert]);

    const onNext = useCallback(() => {
        if (!isComponentValid) {
            setShowErrors(true);
            return false
        }

        setShowErrors(false);

        return saveData().then(() => {
            if (submissionVM.value.errorsAndWarnings) {
                const result = getErrorMessages(submissionVM.value.errorsAndWarnings.validationIssues);

                if (result) {
                    setShowErrors(true)

                    return false;
                }

                return submissionVM;
            }

            return submissionVM;
        }).catch(() => submissionVM)
            // .finally(() => submissionVM);
    }, [isComponentValid, submissionVM, saveData, getErrorMessages])

    const getBuildWizardHeader = useCallback(() => {
        if (!showStepper) {
            switch (wizardStep) {
                case 0: return translator(messages.editLocation)
                case 1: return translator(messages.editBuilding)
                case 2: return translator(messages.editConstruction)
                case 3: return translator(messages.editCoverages)
                case 4: return translator(messages.editAddlInt)
                default: return translator(messages.addBuilding)
            }
        }

        return translator(messages.addBuilding);
    }, [showStepper, translator, wizardStep]);

    // DE17738
    let bcCoverageInfoText = '';
    let bppCoverageInfoText = '';

    const buildingPersonalPropertyCoverageBannerInfo = () => {
        const coverages = submissionVM.selectedBuilding?.coverages;
        const { showBanner, textToChange } = TWIACPCoveragesUtil.infoBannerForBuildingBusinessPropertyCoverage(coverages);
        bppCoverageInfoText = textToChange;
        return showBanner;
    }

    const buildingCoverageBannerInfo = () => {
        const coverages = submissionVM.selectedBuilding?.coverages;
        const { showBanner, textToChange } = TWIACPCoveragesUtil.infoBannerForBuildingCoverage(coverages);
        bcCoverageInfoText = textToChange
        return showBanner;
    }

    const generalProps = {
        submissionVM,
        updateWizardData,
        handleNextClick,
        handleCancelClick,
        handleEditLinkClick,
        selectedLocation,
        selectedBuilding,
        isCommercial,
        showStepper,
        wizardStep,
        validateCoverages,
        editLocationBuilding,
        showCoverageError
    }

    const overrideProps = {
        // As part of DE17380 removed 'or' condtion  ( wizardStep === -1 && !hasBuildingList)
        // Buildings and Locations screen header not updated after removal of building and addition of new building
        initialScreen: {
            visible: wizardStep === -1 && !hasBuildings
        },
        buildingListContainer: {
            visible: (wizardStep === -1 && hasBuildings) || showBuildingList ,
            submissionVM,
            startWizard,
            newlyAddedBuildingList,
            setViewingLocationOrBuilding,
            selectedBuilding,
            setHasBuildingList,
            handleEditLinkClick,
            showViewLocation,
            showViewCoverages,
            setshowViewCoverages,
            wizardStep,
            showLocationAccordion,
            showBuildingAccordion,
            showConstructionAccordion,
            showCoverageAccordion,
            showAdditionalInterestAccordion,
            showStepper,
            showHideBuildingList,
            updateWizardData
        },
        addBuildingWizardContainer: {
            visible: wizardStep > -1
        },
        wizardStepper: {
            visible: showStepper,
            steps,
            currentIndex: wizardStep,
            setWizardStep,
            submissionVM
        },
        locationStep: {
            visible: wizardStep === 0,
            ...generalProps
        },
        buildingStep: {
            visible: wizardStep === 1,
            ...generalProps
        },
        constructionStep: {
            visible: wizardStep === 2,
            ...generalProps
        },
        coveragesStep: {
            visible: wizardStep === 3,
            ...generalProps
        },
        additionalInterestsStep: {
            visible: wizardStep === 4,
            ...generalProps
        },
        confirmationStep: {
            visible: wizardStep === 5,
            handleDoneClick,
            handleEditLinkClick,
            handleAnotherClick,
            selectedBuilding,
            submissionVM
        },
        wizardTitle: {
            content: getBuildWizardHeader()
        },
        errorMessage: {
            data: errorSets
        },
        BCCovLimitAndBCRCVNotification:{
            visible: wizardStep === 3 && buildingCoverageBannerInfo(),
            message: translator(messages.BCCovLimitAndBCRCV, {text: bcCoverageInfoText})
        },
        BPCovLimitAndBPRCVNotification:{
            visible: wizardStep === 3 && buildingPersonalPropertyCoverageBannerInfo(),
            message: translator(messages.BPCovLimitAndBPRCV, {text: bppCoverageInfoText})
        },
        ...generateOverrides,
    }

    const resolvers = {
        resolveClassNameMap: { ...styles, ...wizardStyles },
        resolveCallbackMap: {
            startWizard,
            handleNextClick,
            handleDoneClick,
            handleCancelClick,
            handleAnotherClick
        },
        resolveComponentMap: {
            TWIABuildingStepper,
            LocationStep,
            BuildingStep,
            ConstructionStep,
            CoveragesStep,
            AdditionalInterestsStep,
            ConfirmationStep,
            TWIABuildingList
        }
    }

    const skip = useCallback(async vm => {
        const ppStatus = _.get(submissionVM.value, 'baseData.periodStatus') 
        || _.get(submissionVM.value, 'status');
        return (await initialValidation()) && ppStatus === 'Quoted';
    }, [initialValidation, submissionVM]);

    return (
        <WizardPage
            onNext={onNext}
            showNext={wizardStep === -1 && !viewingLocationOrBuilding}
            showPrevious={wizardStep === -1 && !viewingLocationOrBuilding}
            showCancel={wizardStep === -1 && !viewingLocationOrBuilding}
            disableNext={!hasBuildings} // DE17363
            skipWhen={skip}
        >
            <BuildingLocationContext>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    showErrors={showErrors}
                />
            </BuildingLocationContext>
        </WizardPage>
    )
}

export default BuildingsAndLocationsPage